export default "b26215b4f3480284.svg"